<template>
  <div
    v-if="initialized && display()"
    :id="config.id"
    class="magic-ui-pc-container"
    :style="style"
    :class="className"
  >
    <magic-ui-container
      :config="containerConfig"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { transformStyle } from '@tencent/magic-ui-util';
import scrollMixin from '../../../src/mixins/scroll';

export default {
  name: 'MagicUiPcContainer',

  mixins: [scrollMixin],

  inject: {
    app: {
      default: {},
    },
  },

  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      initialized: false,
    };
  },

  computed: {
    className() {
      if (!this.config) {
        return '';
      }

      let { className } = this.config;
      if (typeof className === 'function') {
        className = className(this, { model: this.model });
      }
      if (Array.isArray(className)) {
        className = [...className];
      } else if (typeof className === 'string') {
        className = [className];
      } else {
        className = [];
      }

      if (!this.inMagic && this.scrollHide) {
        className.push('magic-scroll-hide');
      }

      return className.join(' ');
    },

    originStyle() {
      if (!this.config) {
        return '';
      }

      let style = this.config.style || {};

      if (typeof style === 'function') {
        style = style.bind(this)(this, { model: this.model });
      } else {
        style = transformStyle(style, Vue, false, 375);
      }

      return style;
    },

    style() {
      return {
        width: '100%',
        position: this.originStyle.position || 'relative',
        top: this.originStyle.top,
        bottom: this.originStyle.bottom,
        left: this.originStyle.left,
        right: this.originStyle.right,
        height: this.originStyle.height,
        backgroundColor: this.originStyle.backgroundColor,
        zIndex: this.originStyle.position === 'fixed' ? '500' : 'auto',
      };
    },

    containerConfig() {
      return {
        items: [
          ...(this.config.items || []),
        ],
        style: {
          position: 'relative',
          width: this.originStyle.width,
          height: '100%',
          backgroundImage: this.originStyle.backgroundImage,
          backgroundRepeat: this.originStyle.backgroundRepeat,
          backgroundSize: this.originStyle.backgroundSize,
          margin: '0 auto',
        },
        report: this.config.report,
      };
    },
  },

  created() {
    if (this.config?.id) {
      this.app.addContainer(this);
    }

    if (!this.config.created) {
      this.initialized = true;
    } else if (typeof this.config.created === 'function') {
      Promise.resolve(this.config.created.call(this, this, this.app)).then(() => {
        this.initialized = true;
      });
    }
  },

  beforeMount() {
    typeof this.config.beforeMount === 'function' && this.config.beforeMount.call(this, this, this.app);
  },

  mounted() {
    typeof this.config.mounted === 'function' && this.config.mounted.call(this, this, this.app);
  },

  async destroyed() {
    if (this.config?.id) {
      this.app.removeContainer(this);
    }

    if (typeof this.config.destroyed === 'function') {
      await this.config.destroyed();
    }
  },

  methods: {
    display() {
      const fuc = this.config.display;
      if (typeof fuc === 'function') {
        return fuc.bind(this)(this, { model: this.model });
      }

      if (fuc === false) {
        return fuc;
      }

      return true;
    },
  },
};
</script>
